export namespace NClientFiles {
  export type ModelClientFileForCreation = {
    ClientId: number;
    Description: string | null;
    FileName: string | null;
    Data: string | null;
    NewName?: string | null;
    Size?: number | null;
  };

  export type MediaFilesSizes = {
    Id: number;
    Width: number;
    Height: number;
  };

  export type MediaFiles = {
    id: number;
    data: string;
  };
}
